import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { CIP30Instance } from 'kuber-client/types';

export interface IWalletInfo {
  stakeAddress: string;
  drepIdBech32?: string;
  isExpiremental?: boolean;
}

export interface IConnectedWallet {
  name: string;
  icon: string;
  instance: CIP30Instance | null;
  network: number | string | null;
  walletInfo: IWalletInfo | null;
}

const initialState: IConnectedWallet = {
  name: '',
  icon: '',
  instance: null,
  network: null,
  walletInfo: null,
};

export const walletSlice = createSlice({
  name: 'wallet',
  initialState,
  reducers: {
    setWallet: (state, action: PayloadAction<IConnectedWallet>) => {
      state = action.payload;
      return state;
    },
    removeWallet: (state) => {
      state = initialState;
      return state;
    },
  },
});

export const { setWallet, removeWallet } = walletSlice.actions;
export default walletSlice.reducer;
